import React, { useEffect } from "react";

import useNavigation from "@/utils/useNavigate";
import KeepAlive from "react-activation";
import { useSearchParams } from "react-router-dom";
import Index from "./index";

interface Props {
  pagePath?: any;
}
/**
 * 逛一逛页面
 */
const PromoteContainer: React.FC<Props> = () => {
  const {navigate } = useNavigation();
  const [search] = useSearchParams();
  const materialNo = search.get("materialNo") || "0";
  const objectIds = search.get("objectIds") || "0";
  const fromPage = search.get("fromPage") || "";
  // 注：其实逛一逛没有cacheKey里需要的3个参数中的任何一个
  const cacheKey = `zhongcaoshouye-${materialNo}-${objectIds}-${fromPage}`;

  // 以前逛一逛和种草专区页面是合并的，现在拆分了，这里兼容一下老的url
  useEffect(() => {
    if(fromPage === "productDetail"){
      const searchParams = new URLSearchParams(search);
      const queryString = searchParams.toString();
      const path = `/mx-shop-micro/real-shot-list?${queryString}`;
      console.error("种草专区页面已经抽取到独立的页面，路径为mx-shop-micro/real-shot-list，请直接跳转");
      navigate({
        h5Options: {
          url: path,
        },
        replace: true,
      });
      return;  
    }
  }, [search]);

  return (
    <KeepAlive cacheKey={cacheKey} saveScrollPosition={true}>
      <Index />
    </KeepAlive>
  );
};

export default PromoteContainer;
